var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScalable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_5421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.79785V8.79785",
    stroke: "#56708A",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5.79785L10.5858 4.21207C11.3668 3.43102 12.6332 3.43102 13.4142 4.21207L15 5.79785",
    stroke: "#56708A",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22.7979V16.7979",
    stroke: "#56708A",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 19.7979L13.4142 21.3836C12.6332 22.1647 11.3668 22.1647 10.5858 21.3836L9 19.7979",
    stroke: "#56708A",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17.7979H19C20.105 17.7979 21 16.9029 21 15.7979V9.79785C21 8.69285 20.105 7.79785 19 7.79785H17",
    stroke: "#56708A",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 17.7979H5C3.895 17.7979 3 16.9029 3 15.7979V9.79785C3 8.69285 3.895 7.79785 5 7.79785H7",
    stroke: "#56708A",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_5421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.797852)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalable);
export default __webpack_public_path__ + "static/media/Scalable.61733fdde5a4ef59882de578a8aa1dd2.svg";
export { ForwardRef as ReactComponent };